import { getStateWithOnlyOneLevel } from '../../utils/StateSelectorHelper';

function getPracticeExamState(state) {
  return getStateWithOnlyOneLevel(state, 'practiceExamReducer');
}

export const getPracticeExamAvailable = (state) =>
  getPracticeExamState(state).get('practiceExamAvailable');

export const getTimerDisplay = (state) =>
  getPracticeExamState(state).get('timerDisplay');

export const getIsLoading = (state) =>
  getPracticeExamState(state).get('isLoading');

export const getTimer = (state) => getPracticeExamState(state).get('timer');

export const getTimerStarted = (state) =>
  getPracticeExamState(state).get('timerStarted');

export const getResultsSummarized = (state) =>
  getPracticeExamState(state).get('resultsSummarized');

export const getExamQuestions = (state) =>
  getPracticeExamState(state).get('questions');

export const getPracticeExam = (state) =>
  getPracticeExamState(state).get('practiceExam');

export const getSubmitPracticeExamSuccess = (state) =>
  getPracticeExamState(state).get('submitPracticeExamSuccess');

export const getSubmitPracticeExamLoading = (state) =>
  getPracticeExamState(state).get('submitPracticeExamLoading');

export const getcheckPracticeExamLoading = (state) =>
  getPracticeExamState(state).get('checkPracticeExamLoading');

export const getcheckPracticeExamFlag = (state) =>
  getPracticeExamState(state).get('checkPracticeExamFlag');

export const getReviewMode = (state) =>
  getPracticeExamState(state).get('reviewMode');

export const getRetakeMode = (state) =>
  getPracticeExamState(state).get('retakeMode');

export const getCustomPracticeExam = (state) =>
  getPracticeExamState(state).get('customPracticeExam');

export const getCustomPracticeExamStatus = (state) =>
  getPracticeExamState(state).get('customPracticeExamStatus');

export const getCustomPracticeExamLoading = (state) =>
  getPracticeExamState(state).get('customPracticeExamLoading');

export const getCustomPracticeExamRef = (state) =>
  getPracticeExamState(state).get('customPracticeExamReferences');

export const getCustomPracticeExamReferencesLoading = (state) =>
  getPracticeExamState(state).get('customPracticeExamReferencesLoading');

export const getCustomPESettings = (state) =>
  getPracticeExamState(state).get('customPracticeExamSettings');

export const getCustomPracticeExamSettingsLoading = (state) =>
  getPracticeExamState(state).get('customPracticeExamSettingsLoading');
